import { CoObjectAdvancedPanelTable } from "../table/CoObjectAdvancedPanelTable";
import { SourceTypeEnum } from "../../../api/models/source-type-enum";
import { CoObjectAdvancedAmountPanel } from "../amount/CoObjectAdvancedAmountPanel";
import React from "react";
import { ObjectPanelTabs } from "./ObjectPanelComponent";

interface AdvancedPanelContainerProps {
  isEdit: boolean;
  isLocked: boolean;
  isComponentInstance: boolean;
  objectType: string;
  objectSource: any;
  selectedKey: number;
  updateObjectAdvanced: (obj, tabValid, modified) => void;
  objectAdvanced: any;
  tab: ObjectPanelTabs;
  docPartId: string;
  isFileExcelExisting?: boolean;
}

export const AdvancedPanelContainer = (props: AdvancedPanelContainerProps) => {
  const {
    isEdit,
    isLocked,
    isComponentInstance,
    objectType,
    objectSource,
    objectAdvanced,
    updateObjectAdvanced,
    tab,
    docPartId,
    isFileExcelExisting,
  } = props;

  if (!isEdit || objectAdvanced) {
    switch (objectType) {
      case "CHART":
      case "TABLE":
        return (
          <CoObjectAdvancedPanelTable
            objectAdvanced={objectAdvanced}
            tab={tab}
            updateCoObjectAdvancedTable={(obj, tabValid, modified) => updateObjectAdvanced(obj, tabValid, modified)}
            isEdit={isEdit}
            isComponentInstance={isComponentInstance}
            documentPartId={docPartId}
            isFileExcelExisting={isFileExcelExisting}
            isLocked={isLocked}
          />
        );
      case "AMOUNT":
      case "AMOUNT_AIH":
        if (objectSource !== SourceTypeEnum.EXCEL && objectSource !== SourceTypeEnum.TAGETIK_FORM) {
          return (
            <CoObjectAdvancedAmountPanel
              tab={tab}
              isEdit={isEdit}
              isComponentInstance={isComponentInstance}
              updateCoObjectAdvancedAmount={(obj, tabValid, modified) => updateObjectAdvanced(obj, tabValid, modified)}
              objectAdvanced={objectAdvanced}
              documentPartId={docPartId}
              isLocked={isLocked}
            />
          );
        } else {
          return (
            <CoObjectAdvancedPanelTable
              objectAdvanced={objectAdvanced}
              tab={tab}
              updateCoObjectAdvancedTable={(obj, tabValid, modified) => updateObjectAdvanced(obj, tabValid, modified)}
              isEdit={isEdit}
              documentPartId={docPartId}
              isFileExcelExisting={isFileExcelExisting}
              isComponentInstance={isComponentInstance}
              isLocked={isLocked}
            />
          );
        }
    }
  }
  return null;
};
